import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

// Centers everything
export const CenteredContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4),
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
}));

// Trending chips row
export const TrendingSection = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 1400,
  marginBottom: theme.spacing(4),
}));

export const StockCardContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
  gap: theme.spacing(3),
  width: '100%',
}));

export const StockChip = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  borderRadius: 12,
  cursor: 'pointer',
  userSelect: 'none',
  fontWeight: 600,
  backgroundColor: theme.palette.surface?.main || theme.palette.background.paper,
  border: '1px solid rgba(148, 163, 184, 0.1)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 24px rgba(0, 210, 255, 0.15)',
    borderColor: theme.palette.primary.main,
  }
}));

// Chat area (scrollable)
export const ChatContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  maxWidth: 800,
  overflowY: 'auto',
  marginBottom: theme.spacing(2),
  padding: theme.spacing(0, 3),
  backgroundColor: theme.palette.background.default,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(148, 163, 184, 0.3)',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  }
}));

// Individual message bubble
export const MessageBubble = styled(Box)(({ theme, sender }) => ({
  maxWidth: '85%',
  alignSelf: sender === 'user' ? 'flex-end' : 'flex-start',
  borderRadius: 16,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  backgroundColor: sender === 'user' 
    ? theme.palette.primary.main
    : theme.palette.surface?.main || theme.palette.background.paper,
  color: sender === 'user' 
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  border: sender === 'user' 
    ? 'none'
    : '1px solid rgba(148, 163, 184, 0.1)',
  boxShadow: sender === 'user'
    ? '0 4px 12px rgba(0, 210, 255, 0.2)'
    : '0 2px 8px rgba(0, 0, 0, 0.1)',
}));